/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=1cc9d8be&scoped=true&"
import script from "./language-selector.vue?vue&type=script&lang=js&"
export * from "./language-selector.vue?vue&type=script&lang=js&"
import style0 from "./language-selector.vue?vue&type=style&index=0&id=1cc9d8be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9d8be",
  null
  
)

export default component.exports